import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { faCircle } from "@fortawesome/sharp-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ListRow } from "./utils";

export function ProgressFill({ row }: { row: ListRow }) {
    const fillClass = row.isCompleted ? "bg-chameleon-green" : "bg-chameleon-yellow";
    return (
        <div className="w-full h-1.5 bg-compendia-greige-60 rounded-full overflow-hidden">
            <div
                className={`${fillClass} h-1.5 rounded-full transition-[width] duration-500 ease-out`}
                style={{ width: `${row.progressPercent}%` }}
            />
        </div>
    );
}

export function CompletionIndicator({ isCompleted }: { isCompleted: boolean }) {
    if (isCompleted) {
        return (
            <span className="relative inline-flex items-center justify-center size-5 rounded-full bg-chameleon-green">
                <FontAwesomeIcon icon={faCheck} className="text-white text-[10px]" />
            </span>
        );
    }
    return <FontAwesomeIcon icon={faCircle} className="size-5 text-compendia-greige" />;
}
